<template>
  <div class="plv-ia-notice__create">
    <div class="plv-ia-notice__create__editor">
      <div class="plv-ia-notice__create__editor__control">
        <div class="plv-ia-notice__create__editor__menu">
          <div class="plv-ia-notice__create__editor__menu__item plv-ia-notice__create__editor__menu__item_link" :title="t('plvIA.notice.addLink')" @click="tapAddLink"></div>
        </div>

        <div class="plv-ia-notice__create__editor__wordcount"><span>{{ contentLen }}</span>/{{ maxLength }}</div>
      </div>

      <div class="plv-ia-notice__create__editor__txt">
        <div class="plv-ia-notice__create__editor__txt__wrap">
          <textarea
            v-show="!showFake"
            ref="editorInput"
            v-model="inputContent"
            class="plv-ia-notice__create__editor__input"
            :placeholder="t('plvIA.notice.enterNotice')"
            @blur="onTextareaBlur"
            @compositionstart="onTextInputCompositionStart"
            @compositionend="onTextInputCompositionEnd"
            @input="onTextInput"
          ></textarea>
          <div
            v-show="showFake"
            class="plv-ia-notice__create__editor__fake"
            @click="tapFakeInput"
            v-html="fakeInputContent"
          >
          </div>
        </div>
      </div>
    </div>

    <div class="plv-ia-notice__create__footer">
      <button class="plv-ia-btn-new plv-ia-btn-blue" :disabled="!(inputContent.trim()).length" @click="tapSubmit">{{ t('plvIA.notice.publish') }}</button>
      <button v-if="hasContent || isSimpleMode" class="plv-ia-btn-new plv-ia-btn-cancel" @click="tapCancel">{{ t('plvIA.common.cancel') }}</button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
/** 公告字数限制 */
const WORD_COUNT_LIMIT = 200;

export default {
  name: 'NoticeCreate',
  mixins: [Locale],
  props: {
    hasContent: {
      type: Boolean,
      default: false,
    },
    isSimpleMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxLength: WORD_COUNT_LIMIT,
      inputContent: '',
      showFake: false,
      contentLen: 0,
      fakeInputContent: '',
      tapLink: { linkUrl: '', linkTxt: '' }
    };
  },
  mounted() {
    document.body.addEventListener('click', this.handleClickBody, true);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handleClickBody, true);
  },
  methods: {
    // 监听点击link事件
    handleClickBody(e) {
      if (e.target.className.indexOf('js-hyperlink') === -1) return;

      e.stopPropagation();
      const attrs = e.target.attributes;
      let linkUrl = '';
      let linkTxt = '';
      for (let i = 0; i < attrs.length; i++) {
        const attr = attrs[i];
        if (attr.name === 'data-url') {
          linkUrl = attr.value;
        }
        if (attr.name === 'data-txt') {
          linkTxt = attr.value;
        }
      }
      this.tapLink = {
        linkUrl,
        linkTxt
      };
      this.$emit('tap-add-link', {
        linkUrl,
        linkTxt
      });
      return false;
    },
    addLink(link) {
      const { linkUrl, linkTxt, isEdit } = link;
      const str = `[${linkTxt}](${linkUrl})`;
      const oldStr = this.inputContent;
      let newStr = '';
      if (isEdit) { // 修改链接
        newStr = oldStr.replace(`[${this.tapLink.linkTxt}](${this.tapLink.linkUrl})`, str);
      } else { // 添加链接
        const cursorPos = this.getPosition(this.$refs.editorInput);
        newStr = oldStr.slice(0, cursorPos) + str + oldStr.slice(cursorPos);
      }
      // 超出字数限制
      if (this.countWord(newStr) > WORD_COUNT_LIMIT) {
        this.$iaMessage.default('链接文字过长，添加失败');
        return;
      }
      this.textControl(newStr, true);
    },
    tapAddLink() {
      this.$emit('tap-add-link');
    },
    tapSubmit() {
      this.$emit('tap-submit', this.mdToHtml(this.inputContent, 'A'));
    },
    tapCancel() {
      this.$emit('tap-cancel');
    },
    onTextareaBlur() {
      if (this.inputContent) {
        this.showFake = true;
      }
    },
    tapFakeInput() {
      this.showFake = false;
      this.$nextTick(() => {
        this.$refs.editorInput.focus();
      });
    },
    // 处理公告内容字符串
    parseString(str) {
      str = str.replace(/</g, '&lt;').replace(/>/g, '&gt;').trim(); // 过滤 HTML 标签
      str = str.replace(/(^\s*)|(\s*$)/g, ''); // 前后空格处理
      str = str.replace(/\r\n/g, '<br/>'); // IE9、FF、chrome
      str = str.replace(/\n/g, '<br/>'); // IE7-8
      return str;
    },
    mdToHtml(md, nodeType) {
      const reg = /\[([\s\S]+?)\]\(([\s\S]+?)\)/g;
      switch (nodeType) {
        case 'SPAN': {
          const txt = this.parseString(md);
          return txt.replace(reg, '<span class="plv-ia-notice-link js-hyperlink" data-url="$2" data-txt="$1">$1</span>');
        }
        case 'A': {
          const txt = this.parseString(md);
          return txt.replace(reg, '<a href="$2" target="_blank" rel="noreferrer noopener">$1</a>');
        }
        default: {
          return md.replace(reg, '$1');
        }
      }
    },
    countWord(txt) {
      const trueTxt = this.mdToHtml(txt);
      return trueTxt.length;
    },
    cutText(txt) {
      const tryBegin = txt.lastIndexOf('[');
      const tryEnd = txt.lastIndexOf(')');
      if (tryEnd === txt.length - 1 && tryBegin > -1 && tryEnd > -1 && tryBegin < tryEnd) {
        const lastLinkTxt = txt.slice(tryBegin, tryEnd + 1);
        const hasLastLinkTxt = /\[.*\]\(.*\)/.test(lastLinkTxt);
        if (hasLastLinkTxt) {
          txt = txt.slice(0, tryBegin);
        } else {
          txt = txt.slice(0, -1);
        }
      } else {
        txt = txt.slice(0, txt.length - 1);
      }

      while (this.countWord(txt) > WORD_COUNT_LIMIT) {
        txt = this.cutText(txt);
      }

      return txt;
    },
    textControl(txt, isAddLink) {
      let count = this.countWord(txt);

      if (count > WORD_COUNT_LIMIT) {
        txt = this.cutText(txt);
        count = this.countWord(txt);
      }

      // 输入框的值
      this.inputContent = txt;

      this.fakeInputContent = this.mdToHtml(txt, 'SPAN');

      // 更新当前字数
      this.contentLen = count;

      if (isAddLink) {
        this.showFake = !!count;
      }
    },
    // 输入中文时
    onTextInputCompositionStart() {
      this.isCh = true;
    },
    onTextInputCompositionEnd(e) {
      this.isCh = false;
      const val = e.target.value;
      this.textControl(val);
    },
    onTextInput(e) {
      if (this.isCh) return;
      const val = e.target.value;
      this.textControl(val);
    },
    // textarea 获取光标位置
    getPosition(element) {
      let cursorPos = 0;
      if (document.selection) { // IE
        const selectRange = document.selection.createRange();
        selectRange.moveStart('character', -element.value.length);
        cursorPos = selectRange.text.length;
      } else if (element.selectionStart || element.selectionStart === '0') {
        cursorPos = element.selectionStart;
      }
      return cursorPos;
    }
  }
};
</script>;

<style lang="scss" scoped>
$imgPrefix: './images/';

::-webkit-input-placeholder {
  color: #AEAEAE;
}

.plv-ia-notice__create {
  box-sizing: border-box;
  padding: 16px;
  padding-bottom: 80px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

.plv-ia-notice__create__editor {
  width: 100%;
  height: 100%;
  border: 1px solid #D8D8D8;
  position: relative;
}

.plv-ia-notice__create__editor__control {
  box-sizing: border-box;
  line-height: 32px;
  border-bottom: 1px solid #D8D8D8;
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.plv-ia-notice__create__editor__menu__item {
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 32px;
  cursor: pointer;
}

.plv-ia-notice__create__editor__menu__item_link {
  background-image: url($imgPrefix + 'btn-link.png');
}

.plv-ia-notice__create__editor__wordcount {
  font-size: 12px;
  color: #999;
}

.plv-ia-notice__create__editor__txt {
  height: 100%;
  padding-top: 32px + 1px;
  box-sizing: border-box;
}

.plv-ia-notice__create__editor__txt__wrap {
  height: 100%;
  position: relative;
}

@mixin fakeInput {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: 16px;
  font-size: 14px;
  line-height: 24px;
  word-break: break-all;
  cursor: text;
  color: #333;
}

.plv-ia-notice__create__editor__input {
  @include fakeInput;

  border: none;
  outline: none;
  resize: none;
}

.plv-ia-notice__create__editor__fake {
  @include fakeInput;

  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  overflow: auto;
}

.plv-ia-notice__create__footer {
  display: flex;
  justify-content: center;
  padding: 24px 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;

  button+button {
    margin-left: 16px;
  }
}
</style>

<style lang="scss">
.plv-ia-notice-link {
  color: #2196f3;
  cursor: pointer;
}
</style>
